export const TYPE_PANNEAU_LC = 'panneauLc';
export const TYPE_RESEAU_PERSONNALISE_FACE = 'Face';
export const TYPE_RESEAU_PERSONNALISE_RESEAU_TEMPORAIRE = 'Réseau Temporaire';
export const TYPE_RESEAU_PERSONNALISE_RESEAU_LC = 'Réseau LC';
export const TYPE_RESEAU_PERSONNALISE_PANNEAU_NUMERIQUE = 'Panneau numérique';
export const TYPE_RESEAU_PERSONNALISE_RESEAU_NUMERIQUE = 'Réseau numérique';



// WEBPACK FOOTER //
// ./src/components/creationOpportunite/configuration/panierConf.js